export enum PlayerActionTypes {
  PLAYER_LOGIN_USER = "PLAYER_LOGIN_USER",
  PLAYER_CLEAR_USER = "PLAYER_CLEAR_USER",
  PLAYER_WEAR_EQUIP = "PLAYER_WEAR_EQUIP",
  PLAYER_CAST_EQUIP = "PLAYER_CAST_EQUIP",
  /**
   * 有2个参数
   * 1. 设置哪个状态
   * 2. 加状态还是减状态多少
   * 3. 防止溢出逻辑判断
   * 4. 最后保存当前状态至浏览器
   */
  PLAYER_SET_STATUS = "PLAYER_SET_STATUS",
  PLAYER_REVIVE = "PLAYER_REVIVE"
}
